import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxCaptchaModule } from 'ngx-captcha'; // use for captcha
import { HttpClientModule } from '@angular/common/http';

// Import component
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HomeComponent } from './home/home.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { GameListComponent } from './game-list/game-list.component';
  import { SingleGameComponent } from './game-list/single-game/single-game.component';
  import { GameFormComponent } from './game-list/game-form/game-form.component';
import { ModalityComponent } from './modality/modality.component';
import { ContactComponent } from './contact/contact.component';


import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ReseauSociauxComponent } from './reseau-sociaux/reseau-sociaux.component';

import { LegalMentionComponent } from './legal-mention/legal-mention.component';

import { SigninComponent } from './auth/signin/signin.component';
import { SignupComponent } from './auth/signup/signup.component';


// Import Services
import { AuthService } from './services/auth.service';
import { GamesService } from './services/games.service';
import { ContactMessageService } from './services/contactMessage.service';
import { AuthGuardService } from './services/auth-guard.service';

// Import Pipe
import { DatePipe } from '@angular/common'

// Import Routes
import { Routes, RouterModule } from '@angular/router';
const appRoutes: Routes = [
 
  {path: 'home', component: HomeComponent },
  {path: 'about-us', component: AboutUsComponent },
  {path: 'games', component: GameListComponent },
    {path: 'games/view/:game_name', component: SingleGameComponent },
    {path: 'games/new', canActivate: [AuthGuardService], component: GameFormComponent },
    {path: 'games/new/:game_name', canActivate: [AuthGuardService], component: GameFormComponent },
  {path: 'modality', component: ModalityComponent },  
  {path: 'contact', component: ContactComponent },
  {path: 'legal-mention', component: LegalMentionComponent },
  {path: 'auth/signin', component: SigninComponent },
  {path: 'auth/signup', canActivate: [AuthGuardService], component: SignupComponent },
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {path: '**', redirectTo: 'home'}
];


@NgModule({
  declarations: [
    AppComponent,

    HomeComponent,
    AboutUsComponent,
    GameListComponent,
      SingleGameComponent,
      GameFormComponent,
    ModalityComponent,
    ContactComponent,

    LegalMentionComponent,

    HeaderComponent,
    FooterComponent,
    ReseauSociauxComponent,
    
    SigninComponent,
    SignupComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    
    FormsModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [AuthService, GamesService, ContactMessageService, AuthGuardService, DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
